import { useState } from "react";
import Button from "../UI/Button";
import firebase from "../../firebase/config";
import { useDispatch } from "react-redux";
import { confirmChangePassword, sendOtpForChangePassword } from "../../redux/createMessage/slice";

export default function ChangePassword() {
    const [adminDetails, setAdminDetails] = useState({currentPassword : "", newPassword: "", confirmNewPassword: "", otp: ""});
    const [success, setSuccess] = useState(""); // to display message if the message is sent or not
    const [error, setError] = useState("");
    const [showOtpField, setShowOtpField] = useState(false);
    const [showCurrentPassword, setShowCurrentPassword] = useState(false); // New state for password visibility
    const [showNewPassword, setShowNewPassword] = useState(false); // New state for password visibility
    const [showConfirmPassword, setShowConfirmPassword] = useState(false); // New state for password visibility

    const dispatch = useDispatch();
    
    const getUpdatedDetails = (e: any) => {
        setAdminDetails((prevMessages) => ({
        ...prevMessages,
        [e.target.name]: e.target.value,
      }));
    };

    const sendOtp = async (e: any) => {
      console.log("sendOtp clicked")
        e.preventDefault();
        const adminSnapshot = await firebase.firestore().collection("admin").doc("adminCredentials").get();
        const adminData = adminSnapshot.data();
        const {newPassword, confirmNewPassword, currentPassword} = e.target

        let passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,}$/;

        if (!passwordRegex.test(adminDetails.newPassword)) {
          setError("Password must contain at least one uppercase letter, one number, one special character and minimum of 8 length.");
          setSuccess("")
          return;
        }

        if(adminData && adminData.password === currentPassword.value && newPassword.value === confirmNewPassword.value){
            setSuccess(`OTP sent to your registered email`)
            setError("")
            setShowOtpField(true)
            dispatch(sendOtpForChangePassword())
        }else{
            setError("Please re-check the credentials")
            setSuccess("")
        }
    }

    const confirmOtp= async ()=>{
        const adminSnapshot = await firebase.firestore().collection("admin").doc("adminCredentials").get();
        const adminData = adminSnapshot.data();

        let passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@.#$!%*?&])[A-Za-z\d@.#$!%*?&]{8,}$/;
        if (!passwordRegex.test(adminDetails.newPassword)) {
          setError("Password must contain at least one uppercase letter, one number, one special character and minimum of 8 length.");
          setSuccess("")
          return;
        }
        if(adminData && adminData.password === adminDetails.currentPassword && adminDetails.newPassword === adminDetails.confirmNewPassword && adminData.otp === Number(adminDetails.otp)){
          dispatch(confirmChangePassword(adminDetails)) ;
          setSuccess("Password changed successfully")
          setError("")
          setAdminDetails({
            currentPassword: "",
            newPassword: "",
            confirmNewPassword: "",
            otp: "",
          });
          setShowOtpField(false)

        }else{
          setError("Please re-check, Something went wrong")
          setSuccess("")
        }
      }

  return (
    <main>
      <div className="container-fluid px-4">
        <div>
          <h1>Change Password</h1>
        </div>
        <div className="row">
          <div className="col-md-12">
            <form 
            onSubmit={sendOtp}
            >
              <div className="form-row">
              Enter Current Password:
                <div className="d-flex">
                  <input
                    type={showCurrentPassword ? "text" : "password"}
                    placeholder="Enter Current Password"
                    className="form-control"
                    style={{color:"black"}}
                    id=""
                    name="currentPassword"
                    value={adminDetails.currentPassword}
                    onChange={getUpdatedDetails}
                  />
                  <button
                    className="btn rounded-0 rounded-end"
                    type="button"
                    onClick={() => {
                      setShowCurrentPassword(!showCurrentPassword); // Toggle the password visibility
                    }}>
                    {showCurrentPassword ? "Hide" : "Show"}
                  </button>
              </div>
              </div>
              <div className="form-row">
              New Password: 
                <div className="d-flex">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    placeholder="New Password"
                    className="form-control"
                    style={{color:"black"}}
                    id=""
                    name="newPassword"
                    value={adminDetails.newPassword}
                    onChange={getUpdatedDetails}
                  />
                  <button
                    className="btn rounded-0 rounded-end"
                    type="button"
                    onClick={() => {
                      setShowNewPassword(!showNewPassword); // Toggle the password visibility
                    }}>
                    {showNewPassword ? "Hide" : "Show"}
                  </button>
                </div>
              </div>
              <div className="form-row">
              Confirm New Password:
                <div className="d-flex">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    placeholder="Confirm New Password"
                    className="form-control"
                    style={{color:"black"}}
                    id=""
                    name="confirmNewPassword"
                    value={adminDetails.confirmNewPassword}
                    onChange={getUpdatedDetails}
                  />
                  <button
                    className="btn rounded-0 rounded-end"
                    type="button"
                    onClick={() => {
                      setShowConfirmPassword(!showConfirmPassword); // Toggle the password visibility
                    }}>
                    {showConfirmPassword ? "Hide" : "Show"}
                  </button>
                  </div>
              </div>
              

              {showOtpField &&  <div className="form-row">
                                   Enter OTP:<input
                                    type="number"
                                    placeholder="Enter OTP"
                                    className="form-control"
                                    style={{color:"black"}}
                                    id=""
                                    name="otp"
                                    value={adminDetails.otp}
                                    onChange={getUpdatedDetails}
                                    />
                                    </div>
                }
              {error && <p style={{ color: "red" }}>{error}</p>}
              {success && <p style={{ color: "green" }}>{success}</p>}
              {showOtpField ? <Button type = "button" text= "Confirm" className="btn btn-primary btn-lg mx-2" onClick={confirmOtp} /> : null}
              <Button type = "submit" text={showOtpField ? "Resend OTP" : "Send OTP on registered email"} className="btn btn-primary btn-lg"/>
            </form>
          </div>
        </div>
        </div>    
    </main>
  );
}